import './App.css';
import WhatWeDo from './components/whatwedo.jsx';
import Characters from './components/Characters.jsx';
import TopSec from './components/TopSec.jsx';
import AboutUs from './components/AboutUs.jsx';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useLayoutEffect } from 'react';
import Thewhy from './components/thewhy.jsx';
import FormPage from './components/form.jsx';
import BackgroundMusic from './components/MusicPlayer.jsx';
import Navbar from './components/Navbar.jsx';
import Footer_2 from './components/footer_2.jsx';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from './components/Cookies.jsx';
import ChildhoodBlogPage from './components/blogs/Blog.jsx';
import JungleMoralsPage from './components/blogs/JungleMoralsUI.jsx';
// import AdminLogin from "./admin/Login";
// import AdminDashboard from "./admin/Dashboard";
// import AdminRoute from "./admin/AdminRoute";
// import AdminBlogManager from './admin/AdminBlogManager.jsx';
import { HelmetProvider } from "react-helmet-async";
import HelpingKidsLearnEmpathy from './components/blogs/HelpingKidsLearnEmpathy.jsx';
import HowtoTeachKidsNottoWasteFoodandWater from './components/blogs/HowtoTeachKidsNottoWasteFoodandWater.jsx';
import HelpingKidsLearnHowImportantTeamworkIs from './components/blogs/HelpingKidsLearnHowImportantTeamworkIs.jsx';
import HelpingKidsBuildSelfLoveandInnerStrength from './components/blogs/HelpingKidsBuildSelfLoveandInnerStrength.jsx';
import HelpingKidsUseTimeWellandPrepareinAdvance from './components/blogs/HelpingKidsUseTimeWellandPrepareinAdvance.jsx';
import HowtoTeachKidsThatParentsKnowBest from './components/blogs/HowtoTeachKidsThatParentsKnowBest.jsx';
import HowtoTeachKidsDosandDontsforSafetyandKindness from './components/blogs/HowtoTeachKidsDosandDontsforSafetyandKindness.jsx';
import HowtoTeachKidsAboutStrangerSafety from './components/blogs/HowtoTeachKidsAboutStrangerSafety.jsx';
import HowtoTeachKidsNottoTakeWhatIsNotTheirs from './components/blogs/HowtoTeachKidsNottoTakeWhatIsNotTheirs.jsx';
import HowtoTeachKidstoKeepThingsinPlace from './components/blogs/HowtoTeachKidstoKeepThingsinPlace.jsx';
import HelpingKidsLearnThatEveryoneIsBeautiful from './components/blogs/HelpingKidsLearnThatEveryoneIsBeautiful.jsx';
import Helpingkidschoosewhatisrightinsteadofwhatiseasy from './components/blogs/Helpingkidschoosewhatisrightinsteadofwhatiseasy.jsx';
import Helpingkidslearnthathappinesscomesfromwithin from './components/blogs/Helpingkidslearnthathappinesscomesfromwithin.jsx';
import Helpingkidsusetheirmindtosolveproblemsandhelpothers from './components/blogs/Helpingkidsusetheirmindtosolveproblemsandhelpothers.jsx';
import Helpingkidsunderstandthatpeoplemattermorethanthings from './components/blogs/Helpingkidsunderstandthatpeoplemattermorethanthings.jsx';
import Helpingkidslearnwhyspreadingrumourshurtsfriendships from './components/blogs/Helpingkidslearnwhyspreadingrumourshurtsfriendships.jsx';
import Helpingkidsbelieveinthemselvesandtrustthatthingsworkout from './components/blogs/Helpingkidsbelieveinthemselvesandtrustthatthingsworkout.jsx';
import Helpingkidslearntocontrolangerandmanagebigfeelings from './components/blogs/Helpingkidslearntocontrolangerandmanagebigfeelings.jsx';
import HelpingKidsDiscoverTheirInnerPowerandFeelSpecial from './components/blogs/HelpingKidsDiscoverTheirInnerPowerandFeelSpecial.jsx';
import Helpingkidslearnforgivenessandstrengthenfriendships from './components/blogs/Helpingkidslearnforgivenessandstrengthenfriendships.jsx';
import Helpingkidslearntofollowrulesandnotbegreedy from './components/blogs/Helpingkidslearntofollowrulesandnotbegreedy.jsx';
import Helpingkidsbuildhealthyhabitsanddailyroutines from './components/blogs/Helpingkidsbuildhealthyhabitsanddailyroutines.jsx';


function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    const prev = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';
    return () => { window.history.scrollRestoration = prev || 'auto'; };
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    const t1 = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 50);
    const t2 = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 200);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [pathname]);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="appRoot">
        <Navbar />
        {/* <BackgroundMusic /> */}
        <ScrollToTop />
        <ToastContainer />
        <Cookies />
        <main className="appMain">
          <Routes>
            <Route path="/" element={<TopSec />} />
            <Route path="/whatwedo" element={<WhatWeDo />} />
            <Route path="/characters" element={<Characters />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/thewhy" element={<Thewhy />} />
            <Route path="/form" element={<FormPage />} />
            <Route path="/blogs" element={<ChildhoodBlogPage />} />





            {/* Ye line PEHLE daalo */}
            <Route path="/blog/helping-kids-learn-empathy-through-love-and-kindness" element={<HelpingKidsLearnEmpathy />} />
            <Route path="/blog/how-to-teach-kids-not-to-waste-food-and-water" element={<HowtoTeachKidsNottoWasteFoodandWater />} />
            <Route path="/blog/helping-kids-learn-how-important-teamwork-is" element={<HelpingKidsLearnHowImportantTeamworkIs />} />
            <Route path="/blog/helping-kids-build-self-love-and-inner-strength" element={<HelpingKidsBuildSelfLoveandInnerStrength />} />
            <Route path="/blog/helping-kids-use-time-well-and-prepare-in-advance" element={<HelpingKidsUseTimeWellandPrepareinAdvance />} />
            <Route path="/blog/how-to-teach-kids-that-parents-know-best" element={<HowtoTeachKidsThatParentsKnowBest />} />
            <Route path="/blog/how-to-teach-kids-do-s-and-don-ts-for-safety-and-kindness" element={<HowtoTeachKidsDosandDontsforSafetyandKindness />} />
            <Route path="/blog/how-to-teach-kids-about-stranger-safety" element={<HowtoTeachKidsAboutStrangerSafety />} />
            <Route path="/blog/how-to-teach-kids-not-to-take-what-is-not-theirs" element={<HowtoTeachKidsNottoTakeWhatIsNotTheirs />} />
            <Route path="/blog/how-to-teach-kids-to-keep-things-in-place" element={<HowtoTeachKidstoKeepThingsinPlace />} />
            <Route path="/blog/helping-kids-learn-that-everyone-is-beautiful" element={<HelpingKidsLearnThatEveryoneIsBeautiful />} />
            <Route path="/blog/helping-kids-choose-what-is-right-instead-of-what-is-easy" element={<Helpingkidschoosewhatisrightinsteadofwhatiseasy />} />
            <Route path="/blog/helping-kids-learn-that-happiness-comes-from-within" element={<Helpingkidslearnthathappinesscomesfromwithin />}/>
            <Route path="/blog/helping-kids-use-their-mind-to-solve-problems-and-help-others" element={<Helpingkidsusetheirmindtosolveproblemsandhelpothers/>}/>
            <Route path="/blog/helping-kids-understand-that-people-matter-more-than-things" element={<Helpingkidsunderstandthatpeoplemattermorethanthings/>} />
            <Route path='/blog/helping-kids-learn-why-spreading-rumours-hurts-friendships' element={<Helpingkidslearnwhyspreadingrumourshurtsfriendships/>}/>
            <Route path='/blog/helping-kids-believe-in-themselves-and-trust-that-things-workout' element={<Helpingkidsbelieveinthemselvesandtrustthatthingsworkout/>} />
            <Route path='/blog/helping-kids-learn-to-control-anger-and-manage-big-feelings' element={<Helpingkidslearntocontrolangerandmanagebigfeelings/>} />
            <Route path='/blog/helping-Kids-Discover-Their-Inner-Power-and-Feel-Special' element={<HelpingKidsDiscoverTheirInnerPowerandFeelSpecial/>} />
            <Route path='/blog/helping-kids-learn-forgiveness-and-strengthen-friendships' element={<Helpingkidslearnforgivenessandstrengthenfriendships/>} />
            <Route path='/blog/helping-kids-learn-to-follow-rules-and-not-be-greedy' element={<Helpingkidslearntofollowrulesandnotbegreedy/>} />
            <Route path='/blog/helping-kids-build-healthy-habits-and-daily-routines' element={<Helpingkidsbuildhealthyhabitsanddailyroutines/>} />
            {/* Ye BAAD mein */}
            <Route path="/blog/:slug" element={<JungleMoralsPage />} />

            {/* <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard"
              element={
                <AdminRoute>
                  <AdminDashboard />
                  <AdminBlogManager />
                </AdminRoute>
              }
            /> */}
          </Routes>
        </main>
        <Footer_2 />
      </div>
    </HelmetProvider>
  );
}

export default App;